import { observer } from 'mobx-react-lite';

import { useAuditStore } from '@/store/auditStore';
import { useRouterStore } from '@/store/routerStore';

import { AuditFactoryElement } from './factory-element';

export const AuditElements = observer(() => {
  const audit = useAuditStore((state) => state.audit);
  const selectedTabId = useRouterStore((state) => state.selectedTabId);

  if (!audit) return null;

  const cardBodyChildren = audit.templateHandler.schema.children?.[1].children;

  const pageChildren =
    cardBodyChildren?.find(({ props: { value } }) => value === selectedTabId)?.children || [];

  return (
    <>
      {pageChildren.map((element) => (
        <AuditFactoryElement key={element.props.id as string} element={element} />
      ))}
    </>
  );
});
